import React from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import { Button } from "primereact/button";

function ButtonComponent(props: any) {
  const { name, label, onClick, type, ...rest } = props;
  const { values } = useFormikContext();
  return (
    <div className="flex flex-col py-2 mr-5 float-left w-full form-container-padding" id={name.split(".").pop()}>
      <Field
        alt={name}
        name={name}
        type={type ?? "button"}
        label={label}
        onClick={(e: any) => onClick(e, { values, ...rest })}
        {...rest}
        as={Button}
      />
      <ErrorMessage name={name} render={(msg) => <div className="error">{msg}</div>} />
    </div>
  );
}
export default ButtonComponent;
